import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from './Header';
import SideNav from './SideNav';

function Layout() {
  const { t, i18n } = useTranslation();
  let navigate = useNavigate();

  useEffect(() => {
    window.location.href.endsWith('/') && navigate('/home/welcome');
  }, []);

  return (
    <>
      <div className='d-flex w-100 overflow-hidden'>
        {i18n.language === 'en' ? (
          <>
            <div className='d-table-cell'>
              <SideNav />
            </div>
            <div className='d-table-cell w-100'>
              <Header />
              <Outlet />
            </div>
          </>
        ) : (
          <>
            <div className='d-table-cell w-100'>
              <Header />
              <Outlet />
            </div>
            <div className='d-table-cell'>
              <SideNav />
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default Layout;
